<template>
  <div>
    <b-card no-body>
      <template v-if="dataList.length > 0">
        <b-table
          responsive="sm"
          :fields="fields"
          :items="dataList"
          striped
        >
          <template #cell(message)="data">
            <div class="font-small-2">
              {{ data.item.message }}
            </div>
            <hr>
            <div class="d-flex">
              <div class="font-weight-bold text-danger font-small-2 mr-1">
                {{ data.item.name? data.item.name : 'İsim Belirtilmemiş' }}
              </div>
              <div class="font-weight-bold text-warning font-small-2 mr-1">
                {{ data.item.ip_address? data.item.ip_address : 'İp Adresi Gizli' }}
              </div>
              <div class="font-weight-bold text-muted font-small-2">
                {{ moment(data.item.created).format('llll') }}
              </div>
            </div>
          </template>
          <template #cell(rating_avg)="data">
            <b-form-rating
              v-model="data.item.rating_avg"
              no-border
              class="bg-transparent"
              variant="warning"
              readonly
            />
          </template>
          <template #cell(control)="data">
            <b-button
              variant="primary"
              size="sm"
              :to="$route.path + '/view/' + data.item.id"
              block
            >
              <FeatherIcon icon="EyeIcon" />
              Görüntüle
            </b-button>
          </template>
        </b-table>
        <b-card-footer>
          <b-pagination
            v-model="currentPage"
            :total-rows="dataCounts"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-card-footer>
      </template>
      <b-alert
        v-else
        variant="info"
        class="m-2 text-center"
        show
      >
        <div class="alert-body">
          <feather-icon icon="InfoIcon" />
          Henüz geri bildirim notu bulunmuyor.
        </div>
      </b-alert>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BButton, BTable, BCardFooter, BPagination, BAlert, BFormRating,
} from 'bootstrap-vue'

const tableName = 'feedbacks'

export default {
  name: 'PageIndex',
  components: {
    BAlert,
    BPagination,
    BCardFooter,
    BTable,
    BCard,
    BButton,
    BFormRating,
  },
  data() {
    return {
      currentPage: 1,
      baseUrl: this.$store.state.app.baseURL,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'message',
          label: 'Mesaj',
        },
        {
          key: 'rating_avg',
          label: 'ORTALAMA PUAN',
          thClass: 'width-100 text-nowrap text-center',
          tdClass: 'width-100 text-nowrap text-center',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.name AS name`,
          `${tableName}.message AS message`,
          `${tableName}.ip_address AS ip_address`,
          `${tableName}.rating_avg AS rating_avg`,
          'users.name AS username',
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['feedbacks/dataList']
    },
    dataCounts() {
      return this.$store.getters['feedbacks/dataCounts']
    },
    saveData() {
      return this.$store.getters['feedbacks/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('feedbacks/getDataList', this.dataQuery)
    },
  },
}
</script>
